import { Navigate } from 'react-router-dom';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';
import { useOfferBuilderContext } from '../OfferBuilderContext';
import OfferConfirmation from './OfferConfirmation';

const OfferConfirmationLayout = () => {
  const {
    state: { submissionComplete },
  } = useOfferBuilderContext();

  // redirect to build-offer if submission is not complete
  if (!submissionComplete) {
    return <Navigate to={asEnterpriseLink('build-offer')} replace />;
  }

  return <OfferConfirmation />;
};

export default OfferConfirmationLayout;
